import {TEMPLATE_FOLDER} from "../../../common/constants/constants";
import AppConfig from "../../../AppConfig";
import {downloadFolder} from "../../../common/utils/s3Utils";

export const downloadTemplate = async (useCase, domain, s3bucket) => {
    const s3BucketName = AppConfig[domain][s3bucket];
    const s3Key = TEMPLATE_FOLDER + "/" + useCase + "_TEMPLATE";
    await downloadFolder(s3Key, s3BucketName, domain);
}
